import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NgModel, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[gripConfirmInput]',
    providers: [{
            provide: NG_VALIDATORS,
            useExisting: ConfirmInputValidatorDirective,
            multi: true
        }],
    standalone: false
})
export class ConfirmInputValidatorDirective implements Validator {

  @Input() gripConfirmInput: NgModel | null = null;

  validate(control: AbstractControl): ValidationErrors | null {
    if(this.gripConfirmInput?.control.value !== control.value){
      return {
        validateEqual: true
      }
    }
    return null;
  }
}
